/* Dusty Gems Y2K — Now Playing widget
 * - 11 Pixabay-Royalty-Free Tracks
 * - Auto-Advance, Prev/Next, Play/Pause, Mute, Seek, Volume 0.35
 * - Close (×) versteckt UI; Floating-FAB (♪) reaktiviert sie
 * - First-Visit-Hinweis "Musik von Dusty Gems" mit [Musik aus] / [OK]
 * - Persistenz: localStorage (Track-Index, Pause-State, Mute, Closed, NoticeSeen)
 * - Autoplay respektiert Browser-Policies: Start nach erster User-Interaktion
 */
(function () {
  'use strict';

  var LS = {
    idx: 'dg.np.idx',
    paused: 'dg.np.paused',
    muted: 'dg.np.muted',
    closed: 'dg.np.closed',
    notice: 'dg.np.noticeSeen'
  };
  var DEFAULT_VOLUME = 0.35;

  function read(key, fallback) {
    try {
      var v = localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch (e) { return fallback; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, String(value)); } catch (e) {}
  }

  function fmt(s) {
    if (!isFinite(s) || s < 0) return '00:00';
    var m = Math.floor(s / 60).toString().padStart(2, '0');
    var sec = Math.floor(s % 60).toString().padStart(2, '0');
    return m + ':' + sec;
  }

  function init(widget) {
    var audio = widget.querySelector('[data-dg-np-audio]');
    var dataNode = widget.querySelector('script[data-dg-np-tracks]');
    if (!audio || !dataNode) return;

    var tracks = [];
    try { tracks = JSON.parse(dataNode.textContent); } catch (e) { return; }
    if (!tracks.length) return;

    var playBtn = widget.querySelector('[data-dg-np-play]');
    var prevBtn = widget.querySelector('[data-dg-np-prev]');
    var nextBtn = widget.querySelector('[data-dg-np-next]');
    var muteBtn = widget.querySelector('[data-dg-np-mute]');
    var closeBtn = widget.querySelector('[data-dg-np-close]');
    var progress = widget.querySelector('[data-dg-np-progress]');
    var fill = widget.querySelector('[data-dg-np-fill]');
    var cur = widget.querySelector('[data-dg-np-current]');
    var dur = widget.querySelector('[data-dg-np-duration]');
    var titleEl = widget.querySelector('[data-dg-np-title]');
    var artistEl = widget.querySelector('[data-dg-np-artist]');

    var fab = document.querySelector('[data-dg-np-open]');
    var notice = document.querySelector('[data-dg-np-notice]');
    var noticeStopBtn = notice ? notice.querySelector('[data-dg-np-notice-stop]') : null;
    var noticeOkBtn = notice ? notice.querySelector('[data-dg-np-notice-ok]') : null;

    // --- State -------------------------------------------------------------
    var idx = parseInt(read(LS.idx, '0'), 10);
    if (isNaN(idx) || idx < 0 || idx >= tracks.length) idx = 0;

    var userPaused = read(LS.paused, 'false') === 'true';
    var muted = read(LS.muted, 'false') === 'true';
    var closed = read(LS.closed, 'false') === 'true';
    var noticeSeen = read(LS.notice, 'false') === 'true';
    var hasInteracted = false;

    audio.volume = DEFAULT_VOLUME;
    audio.muted = muted;

    function setPlayIcon(playing) {
      if (!playBtn) return;
      playBtn.textContent = playing ? '||' : '▶';
      playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }
    function setMuteIcon() {
      if (!muteBtn) return;
      muteBtn.textContent = audio.muted ? '×' : '♪';
      muteBtn.setAttribute('aria-label', audio.muted ? 'Ton an' : 'Stummschalten');
    }

    function loadTrack(i, autoplay) {
      idx = (i + tracks.length) % tracks.length;
      write(LS.idx, idx);
      var t = tracks[idx];
      audio.src = t.src;
      if (titleEl) titleEl.textContent = t.title || '—';
      if (artistEl) artistEl.textContent = t.artist || '—';
      if (cur) cur.textContent = '00:00';
      if (dur) dur.textContent = '00:00';
      if (fill) fill.style.width = '0%';
      if (autoplay) tryPlay();
    }

    function tryPlay() {
      var p = audio.play();
      if (p && typeof p.then === 'function') {
        p.catch(function () { /* autoplay blocked — wait for gesture */ });
      }
    }

    function setClosed(state) {
      closed = state;
      write(LS.closed, state);
      widget.classList.toggle('is-hidden', state);
      if (fab) fab.classList.toggle('is-hidden', !state);
    }

    // --- Wire controls -----------------------------------------------------
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (audio.paused) {
          userPaused = false;
          write(LS.paused, 'false');
          tryPlay();
        } else {
          userPaused = true;
          write(LS.paused, 'true');
          audio.pause();
        }
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (audio.currentTime > 3) { audio.currentTime = 0; return; }
        loadTrack(idx - 1, !userPaused);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { loadTrack(idx + 1, !userPaused); });
    }
    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        audio.muted = !audio.muted;
        write(LS.muted, audio.muted);
        setMuteIcon();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { setClosed(true); });
    if (fab) fab.addEventListener('click', function () {
      setClosed(false);
      if (!userPaused && audio.paused) tryPlay();
    });

    audio.addEventListener('play', function () { setPlayIcon(true); });
    audio.addEventListener('pause', function () { setPlayIcon(false); });
    audio.addEventListener('ended', function () { loadTrack(idx + 1, true); });
    audio.addEventListener('loadedmetadata', function () {
      if (dur) dur.textContent = fmt(audio.duration);
    });
    audio.addEventListener('timeupdate', function () {
      if (cur) cur.textContent = fmt(audio.currentTime);
      if (fill && audio.duration) {
        fill.style.width = (audio.currentTime / audio.duration * 100) + '%';
      }
    });
    audio.addEventListener('error', function () {
      // Skip broken track after short delay
      setTimeout(function () { loadTrack(idx + 1, !userPaused); }, 500);
    });

    if (progress) {
      progress.addEventListener('click', function (e) {
        var rect = progress.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        if (audio.duration) audio.currentTime = ratio * audio.duration;
      });
    }

    // --- Notice (first visit) ---------------------------------------------
    function showNotice() {
      if (!notice) return;
      notice.classList.remove('is-hidden');
    }
    function hideNotice() {
      if (!notice) return;
      notice.classList.add('is-hidden');
    }
    function dismissNotice() {
      hideNotice();
      noticeSeen = true;
      write(LS.notice, 'true');
    }
    if (noticeOkBtn) noticeOkBtn.addEventListener('click', dismissNotice);
    if (noticeStopBtn) {
      noticeStopBtn.addEventListener('click', function () {
        audio.pause();
        userPaused = true;
        write(LS.paused, 'true');
        dismissNotice();
      });
    }

    // --- Boot --------------------------------------------------------------
    setMuteIcon();
    setClosed(closed);
    loadTrack(idx, false);

    // Start on first user gesture (browser autoplay policy)
    function onFirstGesture() {
      if (hasInteracted) return;
      hasInteracted = true;
      window.removeEventListener('pointerdown', onFirstGesture, true);
      window.removeEventListener('keydown', onFirstGesture, true);
      window.removeEventListener('scroll', onFirstGesture, true);
      window.removeEventListener('touchstart', onFirstGesture, true);

      if (!userPaused && !closed) tryPlay();
      if (!noticeSeen && !closed) {
        // Slight delay so it feels intentional, not a popup-storm
        setTimeout(showNotice, 1200);
      }
    }
    window.addEventListener('pointerdown', onFirstGesture, true);
    window.addEventListener('keydown', onFirstGesture, true);
    window.addEventListener('scroll', onFirstGesture, { capture: true, passive: true });
    window.addEventListener('touchstart', onFirstGesture, { capture: true, passive: true });
  }

  function start() {
    document.querySelectorAll('[data-dg-now-playing]').forEach(init);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
